import { EffectCallback, useEffect } from "react"

export function useEffectSingleCalls(userFunction: EffectCallback, depList: Array<any>) {
    return useEffect(() => {
        let dismountFunc: void | Function
        let id: any = setTimeout(() => {
            id = null
           dismountFunc = userFunction()
        })
        return () => {
           if (id !== null) {
                clearTimeout(id)
            } else if (dismountFunc) {
                 dismountFunc()
            }
        }
    }, depList)
}